import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadTableGender, clearState, monitoringModule, exportGenderTableExcel } from '../MonitoringDucks';
import StaticTablePagination from '../../../_ui/Table/StaticTablePaginated';
import { queuedByGenderColumn } from './QueuedByGenderColumn';
import { useTranslation } from 'react-i18next';
import Button from '../../../_ui/Button/Button';
import ExportIcon from '@material-ui/icons/SaveAlt';

export default function QueuedByGender() {
  const dispatch = useDispatch();
  const data = useSelector(state => state[monitoringModule].tableGenderData);
  const loading = useSelector(state => state[monitoringModule].loadingTable);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    dispatch(loadTableGender());
    return () => dispatch(clearState());
  }, []);
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <Button
          text={t('monitoring_export_btn')}
          icon={<ExportIcon fontSize="small" className="mr1" />}
          onClick={exportGenderTableExcel}
        />
      </div>
      <StaticTablePagination
        loading={loading}
        sortable={false}
        columns={queuedByGenderColumn({
          t,
          lang: i18n.language
        })}
        data={data}
      />
    </div>
  );
}
